module.exports = __webpack_public_path__ + "static/media/hk.804db24d.webp";